export var DEFAULT_MOCK_VERSION_RESPONSE = {
    system_version: {
        rest_api_version: 'v3.7',
        firmware_version: '23.08.0p0',
    },
};
export var VERSION_PATH = '/system/version';
